/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import DiscordAnalyticsMentorExpenseAnalysisDash from "../../../../components/DiscordAnalytics/Mentors/ExpenseAnalysis";
import Navbar from "../../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../../constants/routes";

const DiscordAnalyticsMentorExpenseAnalysis = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.discordAnalytics?.hasMentorExpenseAnalysisAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <DiscordAnalyticsMentorExpenseAnalysisDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default DiscordAnalyticsMentorExpenseAnalysis;
